// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64618467","891":"adcee1dd"}[chunkId] + ".chunk.js";
};